import { render, staticRenderFns } from "./caseHeader.vue?vue&type=template&id=6e09dbc7&scoped=true&"
import script from "./caseHeader.vue?vue&type=script&lang=js&"
export * from "./caseHeader.vue?vue&type=script&lang=js&"
import style0 from "./caseHeader.vue?vue&type=style&index=0&id=6e09dbc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e09dbc7",
  null
  
)

export default component.exports